import { app } from "../Frame/App";

export class LanguageString {
    valueDe: string;
    valueEn: string;
    valueFr: string;
    valueNl: string;
    valueSv: string;
    valueRu: string;
    valueCs: string;
    valueKo: string;

    getForLanguage = (language: string): string => {
        if (language) {
            return this["value" + language.charAt(0).toUpperCase() + language.slice(1)];
        } else {
            return "";
        }
    }

    setForLanguage = (value: string, language: string) => {
        if (language) {
            this["value" + language.charAt(0).toUpperCase() + language.slice(1)] = value;
        }
    }

    get inLanguage(): string {
        // Try to get value in the user language
        let res = this.getForLanguage(app.language);
        if (!res) {
            // Try to get value in default language
            res = this.getForLanguage(app.defaultLanguage);
            if (!res) {
                // Try to get value in the available languages for this application
                for (let lang of app.availableLanguages) {
                    res = this.getForLanguage(lang);
                    if (res) {
                        break;
                    }
                }

                // if there is still no value to be found, check all languages (execpt the one already tested above)
                for (let lang of app.allLanguages.filter(l => app.availableLanguages.indexOf(l) == -1)) {
                    res = this.getForLanguage(lang);
                    if (res) {
                        break;
                    }
                }
            }
        }
        return res;
    }

    set inLanguage(val: string) {
        this.setForLanguage(val, app.languageUpperCase);
    }

    constructor(init?: Partial<LanguageString>) {
        Object.assign(this, init);
        this.valueDe = null;
        this.valueEn = null;
        this.valueFr = null;
        this.valueNl = null;
        this.valueSv = null;
        this.valueRu = null;
        this.valueCs = null;
        this.valueKo = null;
    }

    public static fromPartial(init?: Partial<LanguageString>) {
        let languageString = new LanguageString();
        Object.assign(languageString, init);

        return languageString;
    }

    public isEmpty = () => {
        return !((this.valueCs && this.valueCs.length > 0)
            || (this.valueDe && this.valueDe.length > 0)
            || (this.valueEn && this.valueEn.length > 0)
            || (this.valueFr && this.valueFr.length > 0)
            || (this.valueNl && this.valueNl.length > 0)
            || (this.valueKo && this.valueKo.length > 0)
            || (this.valueRu && this.valueRu.length > 0)
            || (this.valueSv && this.valueSv.length > 0));
    }

    copy = () => {
        let copy = new LanguageString();
        copy.valueCs = this.valueCs;
        copy.valueDe = this.valueDe;
        copy.valueEn = this.valueEn;
        copy.valueFr = this.valueFr;
        copy.valueKo = this.valueKo;
        copy.valueNl = this.valueNl;
        copy.valueRu = this.valueRu;
        copy.valueSv = this.valueSv;
        return copy;
    }
}
